import * as Yup from "yup";

import { patientValidationErrors } from "./messages";

export const patientValidationSchema = Yup.object().shape({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  sex: Yup.string().required("Please select a sex"),
  nhsNumber: Yup.number().typeError("NHS numbers should only contain digits").required("NHS number is required"),
  hospitalNumber: Yup.string().required("Hospital number is required"),
  dateOfBirth: Yup.date().required("Date of birth is required"),
  contactDetails: Yup.object().shape({
    address: Yup.object().shape({
      line1: Yup.string().required("Address Line 1 is required"),
      city: Yup.string().required("City is required"),
      postcode: Yup.string().required("Postcode is required"),
    }),
    email: Yup.string().required("Email is required"),
    primaryContact: Yup.string().required("Primary contact is required"),
    preferredContactMethod: Yup.string().required("Contact preference is required"),
  }),
});

export const patientCreateValidationSchema = patientValidationSchema.shape({
  consent: Yup.object().shape({
    privacyPolicy: Yup.boolean()
      .required(patientValidationErrors.PRIVACY_POLICY_CONSENT_REQUIRED)
      .oneOf([true], patientValidationErrors.PRIVACY_POLICY_CONSENT_REQUIRED),
    service: Yup.boolean()
      .required(patientValidationErrors.SERVICE_CONSENT_REQUIRED)
      .oneOf([true], patientValidationErrors.SERVICE_CONSENT_REQUIRED),
  }),
});
